export function getShiftInfoKey(date: Date, name: string): string {
  return `${name}-${date.toISOString()}`;
}
